import { render, staticRenderFns } from "./Scorecards.vue?vue&type=template&id=20bc1b8c&scoped=true&"
import script from "./Scorecards.vue?vue&type=script&lang=js&"
export * from "./Scorecards.vue?vue&type=script&lang=js&"
import style0 from "./Scorecards.vue?vue&type=style&index=0&id=20bc1b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc1b8c",
  null
  
)

export default component.exports